export default __webpack_public_path__ + "static/media/Screenshot (7).cded3cab.png";